import { PluginFunc } from 'dayjs';
import { Dayjs } from 'dayjs';

const businessDaysPlugin: PluginFunc = (_, dayjsClass) => {
  dayjsClass.prototype.businessDaysAdd = function (days: number): Dayjs {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    let result = this;
    let added = 0;

    while (added < days) {
      result = result.add(1, 'day');
      const day = result.day();
      if (day !== 0 && day !== 6) {
        added++;
      }
    }
    return result;
  };

  dayjsClass.prototype.businessDaysSubtract = function (days: number): Dayjs {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    let result = this;
    let subtracted = 0;

    while (subtracted < days) {
      result = result.subtract(1, 'day');
      const day = result.day();
      if (day !== 0 && day !== 6) {
        subtracted++;
      }
    }
    return result;
  };

  dayjsClass.prototype.isBusinessDay = function (): boolean {
    const day = this.day();
    return day !== 0 && day !== 6;
  };

  dayjsClass.prototype.nextBusinessDay = function (): Dayjs {
    let result = this.add(1, 'day');
    while (!result.isBusinessDay()) {
      result = result.add(1, 'day');
    }
    return result;
  };

  dayjsClass.prototype.prevBusinessDay = function (): Dayjs {
    let result = this.subtract(1, 'day');
    while (!result.isBusinessDay()) {
      result = result.subtract(1, 'day');
    }
    return result;
  };
};

export default businessDaysPlugin;
